export default __webpack_public_path__ + "static/media/Witchborn Tasset.07bce162.jpg";